import { queryKeys } from '@/lib/query-keys';
import { apiClient } from '@borradh-workspace/api-client';
import { conversationDetailSchema } from '@borradh-workspace/contracts';
import { queryOptions, useQuery } from '@tanstack/react-query';
import type { ConversationDetail } from '../types';

export const getConversationQueryOptions = (id: string) =>
  queryOptions({
    queryKey: queryKeys.conversations.detail(id),
    queryFn: () =>
      apiClient.get<ConversationDetail>(`conversations/${id}`, {
        schema: conversationDetailSchema,
      }),
    enabled: !!id,
    staleTime: 30 * 1000,
  });

export const useGetConversation = (id: string) => {
  const query = useQuery(getConversationQueryOptions(id));
  return {
    conversation: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
